const it = {
    report: {
        quote: {
            header: 'Riepilogo',
            extraPrice: 'Maggiorazione netta per commessa con',
            extraColorPrice: '@:report.quote.extraPrice verniciatura Ral fuori standard ',
            color: 'Verniciatura Ral standard',
            colorPVC: 'Pellicola Ral standard PVC',
            colorAluminium: 'Verniciatura Ral standard',
            extraUnit: 'nr',
            colorHeader: '@:color.label',
            position: '@:quoteDetail.position',

            transportCost: '@:report.quote.extraPrice consegna presso sede cliente',
            transportLocation: '@:quote.transportLocation',
            transportTypeCLIENT: '@:quote.transportType.CLIENT',
            transportTypeCOMPANY: '@:quote.transportType.COMPANY',

            measure: '@:quoteDetail.measure.label LxH:',
            measureUnit: '@:quoteDetail.measure.unit',
            measureAxisX: '@:quoteDetail.measure.axisXMin',
            measureAxisY: '@:quoteDetail.measure.axisYMin',

            quoteCode: '@:quote.code',
            quoteDate: '@:quote.dateRef',
            quoteReference: '@:quote.reference',
            quoteDiscount: '@:quote.discount',
            quoteType: '@:quote.quoteType.label',
            quoteTypeORDER: '@:quote.quoteType.ORDER',
            quoteTypeQUOTE: '@:quote.quoteType.QUOTE',
            quoteTypeNONE: '@:quote.quoteType.NONE',
            quoteTypeALL: '@:quote.quoteType.ALL',
            quoteAmoutPreVat: '@:quote.amountPreVat',
            quoteVatAmount: '@:quote.vatAmount',
            quoteTotalWithVat: '@:quote.totalWithVat',
            quoteQuantity: '@:quote.quantity',
            quoteUnitPrice: '@:quote.unitPrice',
            quoteFixedPrice: '@:quote.fixedPrice',
            quoteTotalPrice: '@:quote.totalPrice',

            quoteDetail: 'Scuro in',
            materialType: '@:quote.materialType.label',
            materialTypePVC: '@:quote.materialType.PVC',
            materialTypeALUMINIUM: '@:quote.materialType.ALUMINIUM',
            materialTypeWOOD: '@:quote.materialType.WOOD',


            optionalType: '@:optional.optionalType.label',
            optionalTypeUnit: 'pz',
            optionalTypeTELAIO: '@:optional.optionalType.TELAIO',
            optionalTypeAPERTURA: '@:optional.optionalType.APERTURA',
            optionalTypeCHIUSURA: '@:optional.optionalType.CHIUSURA',
            optionalTypeAPPLICAZIONE: '@:optional.optionalType.APPLICAZIONE',
            optionalTypeDOGA: '@:optional.optionalType.DOGA',
            optionalTypeFERRAMENTA_SOSTEGNO_ESTERNA: '@:optional.optionalType.FERRAMENTA_SOSTEGNO_ESTERNA',
            optionalTypeCARDINI: '@:optional.optionalType.CARDINI',
            optionalTypeMURATURA: '@:optional.optionalType.MURATURA',
            optionalTypeSPALLA: '@:optional.optionalType.SPALLA',
            optionalTypeCONTROTELAIO: '@:optional.optionalType.CONTROTELAIO',
            optionalTypeFERMASCURI: '@:optional.optionalType.FERMASCURI',
            optionalTypeSOLUZIONE_CHIUSURA_SERRATURA: '@:optional.optionalType.SOLUZIONE_CHIUSURA_SERRATURA',
            optionalTypeSEZIONE_MURO: '@:optional.optionalType.SEZIONE_MURO',
            optionalTypeSIDE4: '@:optional.optionalType.SIDE4',
            optionalTypeOTHER: '@:optional.optionalType.OTHER',

            companyName: '@:company.companyName',
            companyAddress: '@:company.address',
            companyFiscal: '@:company.fiscalCodeShort',
            companyVat: '@:company.vatCodeShort',

            registryName: '@:quote.registryName',
            deliveryAddress: '@:quote.deliveryAddress',
            quoteDocStatus: '@:quote.docStatus.label',
            quoteDocStatusDRAFT: '@:quote.docStatus.DRAFT',
            quoteDocStatusREADY: '@:quote.docStatus.READY',
            quoteDocStatusSENT: '@:quote.docStatus.SENT',
            quoteDocStatusRECEIVED: '@:quote.docStatus.RECEIVED',
            quoteDocStatusINPROGRESS: '@:quote.docStatus.INPROGRESS',
            quoteDocStatusONHOLD: '@:quote.docStatus.ONHOLD',
            quoteDocStatusCOMPLETED: '@:quote.docStatus.COMPLETED',
            quoteDocStatusCANCELED: '@:quote.docStatus.CANCELED',

            dimensionType: '@:quoteDetail.dimensionType.label',
            dimensionTypeMEASURE_HOLE: '@:quoteDetail.dimensionType.MEASURE_HOLE',
            dimensionTypeMEASURE_SHUTTERS: '@:quoteDetail.dimensionType.MEASURE_SHUTTERS',

        },



    },
}
export default it
